module.exports = __webpack_public_path__ + "static/img/mc.b9a9860.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/mc.png
// module id = 8w85
// module chunks = 109